import type { ReactNode } from 'react'

type SectionHeadingProps = {
  id: string
  kicker: string
  title: string
  mobileTitle?: string
  introduction?: ReactNode
  mobileIntroduction?: ReactNode
}

export function SectionHeading({ id, kicker, title, mobileTitle, introduction, mobileIntroduction }: SectionHeadingProps) {
  return (
    <header className="section-heading">
      <span className="section-kicker">{kicker}</span>
      <h2 id={id}>
        <span className={mobileTitle ? 'heading-title--desktop' : undefined}>{title}</span>
        {mobileTitle && <span className="heading-title--mobile">{mobileTitle}</span>}
      </h2>
      {introduction && <p className={mobileIntroduction ? 'section-introduction--desktop' : undefined}>{introduction}</p>}
      {mobileIntroduction && <p className="section-introduction--mobile">{mobileIntroduction}</p>}
    </header>
  )
}
